export default __webpack_public_path__ + "static/media/icon-menu-shop.2ef9e5ba.svg";